import React from "react";
import Select from "react-select";
import { reportOption } from "../../utilities";
import { connect, useDispatch } from "react-redux";
import { updateReportAction } from "../../store/actions/AuthActions";

const Reportselect = ({ reportType }) => {
  const dispatch = useDispatch();

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "250px", // Limit height for scrollbar visibility
      overflowY: "auto",
      // Custom Scrollbar Styles
      scrollbarWidth: "thin",
      scrollbarColor: "#626463ff #e9ecef",
    }),
  };

  return (
    <div>
      <Select
        className="react-select"
        classNamePrefix="select"
        options={reportOption}
        value={reportType}
        onChange={(selected) => {
          dispatch(updateReportAction(selected));
        }}
        styles={customStyles}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  reportType: state.auth.reportType,
});

export default connect(mapStateToProps)(Reportselect);
